<ng-container *ngIf="shouldDisplayZoomPanelSettings">
  <h3-checkbox [nasModel]="zoomPanelEnabledStore">
    Enable zoom panel
  </h3-checkbox>
  <h3-checkbox
    *ngIf="shouldDisplayAltImageSetting"
    [nasModel]="altImageEnabledStore"
  >
    Enable helper image for zoom panel
  </h3-checkbox>
</ng-container>
